(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sizeGuideInit) return;
    window.__sizeGuideInit = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var openButton = target.closest('[data-size-guide-open]');
      if (openButton) {
        var wrapper = openButton.closest('.size-guide');
        var dialog = wrapper && wrapper.querySelector('dialog');
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      var closeButton = target.closest('[data-size-guide-close]');
      if (closeButton) {
        var parentDialog = closeButton.closest('dialog');
        if (parentDialog) parentDialog.close();
        return;
      }

      // Click on the dimmed backdrop (outside the panel) closes it
      if (target.matches('dialog.size-guide__dialog')) target.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
